// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_COLORS = {
  primary: [
    "#e8f3ff", // Xanh dương nhạt nhất, tương đương với #fff9db
    "#d0e7ff", // Xanh dương pastel, tương đương với #fff3bf
    "#b0d9ff", // Xanh dương sáng, tương đương với #ffec99
    "#8ecaff", // Xanh dương trung bình, tương đương với #ffe066
    "#6dbbff", // Xanh dương tươi, tương đương với #ffd43b
    "#4ca9f5", // Xanh dương rực rỡ, tương đương với #fcc419
    "#2A81D0", // Xanh dương chủ đạo (giữ nguyên)
    "#206eb6", // Xanh dương đậm hơn một chút, tương đương với #0c4da2
    "#175a9c", // Xanh dương đậm hơn, tương đương với #f08c00
    "#104783", // Xanh dương đậm nhất, tương đương với #e67700
  ],
  secondary: [
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e",
  ],
  tertiary: [
    "#f9f3eb",
    "#f3e7d8",
    "#ecdbc4",
    "#e6cfb1",
    "#e0c39d",
    "#dab789",
    "#d4ab76",
    "#cd9f62",
    "#c7934f",
    "#2A81D0",
  ],
  dark: [
    "#C1C2C5",
    "#A6A7AB",
    "#909296",
    "#666666",
    "#373A40",
    "#2C2E33",
    "#25262b",
    "#1A1B1E",
    "#141517",
    "#101113",
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529",
  ],
  white: ["#fff"],
  error: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a",
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#00269A",
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7",
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b",
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f",
  ],
  neutral: [
    "#f2f2f2",
    "#e0e0e0",
    "#cfcfcf",
    "#bfbfbf",
    "#a0a0a0",
    "#8c8c8c",
    "#787878",
    "#656565",
    "#5E656B",
    "#4a4a4a",
  ],
};
